import "../styles/Registrations.css";

export default function Registration() {
  return (
    <div className="reg-page">
      {/* HERO */}
      <section className="reg-hero">
        <div className="reg-hero-overlay">
          <p className="reg-hero-tag">MAGIC 2026</p>

          <h1 className="reg-hero-title">
            Registration
          </h1>

          <div className="reg-hero-meta">
            <span>
              📍 Indian Institute of Millets Research, Hyderabad, India
            </span>
          </div>
        </div>
      </section>

      {/* REGISTRATION STATUS */}
      <div className="reg-form-outer">
        <div className="reg-form-card">
          <div className="reg-success">
            <div className="reg-success-icon">⏳</div>

            <h2>
              MAGIC (Millets and Ancient Grains International Conference)
              under MAHARISHI has been postponed.
            </h2>

            <p>
              Revised dates and registration details will be announced soon.
            </p>

            <p>
              For any queries, contact us at:{" "}
              <strong>maharishi.iimr@gmail.com</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}